/* CreoGlass bespoke splashback configurator v2 – Oct 2026. No dependencies.
   Pricing is identical to v1 (snippets/cg-splash-configurator.liquid):
     glass   = max(min_charge_m2, w × h in m²) × quantity × rate (inc VAT)
     cut-outs = count × price (socket £44.40, hole £42.00, notch £44.40, custom priced later) – per panel line, not × quantity
     shaping = large notches (L = 1, inverted T = 2) × £70.80 × quantity
   Checkout and enquiry use the same CreoGlass OS endpoints and payloads as v1. The server re-prices the order.
   Fitting area (measured and fitted): inside the M25 and up to 20 miles beyond.
   Outside the M25 an estimated mileage charge (selling rate) is shown; it is confirmed in the quote. */
(function () {
  'use strict';

  var CUT_PRICE = { socket: 44.40, hole: 42.00, notch: 44.40, custom: 0 };
  var LARGE_NOTCH = 70.80;
  var SHAPE_LARGE = { rectangle: 0, l: 1, t: 2 };
  var SHAPE_LABEL = { rectangle: 'Rectangle', l: 'L-shape', t: 'Inverted T' };
  var MAX_QTY = 20, MAX_CUT = 20;
  var FIT = { buffer: 20, base: [51.41, -0.18], roadFactor: 1.3, trips: 4, rate: 0.45, vat: 0.2 }; // rate = selling rate per mile ex VAT

  function money(v) { return '£' + Number(v || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function moneyEx(v) { return money((v || 0) / (1 + FIT.vat)); } // display ex VAT (prices held inc VAT)
  function moneyVat(v) { return moneyEx(v) + ' + VAT'; }
  function money1(v) { return '£' + Number(v || 0).toFixed(2); } // v1 text format, sent to the OS
  function r1(v) { return Math.round(v * 10) / 10; }
  function intOf(v) { var n = parseInt(String(v == null ? '' : v).replace(/[^0-9]/g, ''), 10); return isFinite(n) ? n : 0; }

  // ---- Pricing (shared with tests) ----
  function panelPrice(cfg, p) {
    var w = intOf(p.w), h = intOf(p.h), q = Math.max(1, intOf(p.qty) || 1);
    var charge = Math.max(cfg.min, (w / 1000) * (h / 1000)) * q;
    var glass = charge * cfg.rate, cutCount = 0, cutouts = 0;
    Object.keys(CUT_PRICE).forEach(function (k) { var n = intOf(p.cuts[k]); cutCount += n; cutouts += n * CUT_PRICE[k]; });
    var shaping = (SHAPE_LARGE[p.shape] || 0) * LARGE_NOTCH * q;
    return { w: w, h: h, q: q, charge: charge, glass: glass, cutCount: cutCount, cutouts: cutouts, shaping: shaping, total: glass + cutouts + shaping, needsFile: p.shape !== 'rectangle' || cutCount > 0 };
  }

  // Size limits: toughened mirror long edge ≤ 3100, short edge ≤ 1100 (either way round); glass width ≤ 3200, height ≤ 1800.
  function limitErrors(cfg, w, h) {
    var r = { w: '', h: '' };
    if (cfg.mirror) {
      if (Math.max(w, h) > 3100) { if (w >= h) r.w = 'Toughened mirror: max 3100 mm long'; else r.h = 'Toughened mirror: max 3100 mm long'; }
      if (Math.min(w, h) > 1100) { if (w <= h) r.w = r.w || 'Toughened mirror: one side must be 1100 mm or less'; else r.h = r.h || 'Toughened mirror: one side must be 1100 mm or less'; }
    } else {
      if (w > 3200) r.w = 'Maximum width is 3200 mm';
      if (h > 1800) r.h = 'Maximum height is 1800 mm';
    }
    if (!r.w && w > 0 && w < 100) r.w = 'Minimum width is 100 mm';
    if (!r.h && h > 0 && h < 100) r.h = 'Minimum height is 100 mm';
    return r;
  }

  // ---- Fitting area (M25 outline from approximate junctions, as the gym calculator) ----
  var M25 = [[51.463,0.258],[51.420,0.243],[51.396,0.176],[51.358,0.105],[51.285,0.123],[51.255,-0.060],[51.258,-0.124],[51.263,-0.215],[51.300,-0.322],[51.318,-0.442],[51.375,-0.513],[51.400,-0.525],[51.437,-0.524],[51.462,-0.519],[51.490,-0.513],[51.562,-0.502],[51.618,-0.497],[51.645,-0.488],[51.689,-0.425],[51.713,-0.379],[51.719,-0.357],[51.716,-0.295],[51.693,-0.215],[51.687,-0.161],[51.683,-0.047],[51.680,0.010],[51.652,0.074],[51.617,0.245],[51.581,0.273],[51.494,0.286]];
  var CENTRE = [51.5074, -0.1278];
  function toMi(p) { return [(p[1] - CENTRE[1]) * 69 * Math.cos(51.5 * Math.PI / 180), (CENTRE[0] - p[0]) * 69]; }
  var M25MI = M25.map(toMi);
  function inPoly(q, poly) { var c = false; for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) { var a = poly[i], b = poly[j]; if ((a[1] > q[1]) !== (b[1] > q[1]) && q[0] < (b[0] - a[0]) * (q[1] - a[1]) / (b[1] - a[1]) + a[0]) c = !c; } return c; }
  function segDist(q, a, b) { var dx = b[0] - a[0], dy = b[1] - a[1], t = ((q[0] - a[0]) * dx + (q[1] - a[1]) * dy) / (dx * dx + dy * dy); t = Math.max(0, Math.min(1, t)); return Math.hypot(q[0] - a[0] - t * dx, q[1] - a[1] - t * dy); }
  function milesOutsideM25(ll) { var q = toMi(ll); if (inPoly(q, M25MI)) return 0; var m = Infinity; for (var i = 0; i < M25MI.length; i++) m = Math.min(m, segDist(q, M25MI[i], M25MI[(i + 1) % M25MI.length])); return m; }
  function milesBetween(a, b) { var R = 3958.8, k = Math.PI / 180, dLat = (b[0] - a[0]) * k, dLon = (b[1] - a[1]) * k; var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a[0] * k) * Math.cos(b[0] * k) * Math.sin(dLon / 2) * Math.sin(dLon / 2); return 2 * R * Math.asin(Math.sqrt(x)); }
  function fitArea(ll) {
    var out = milesOutsideM25(ll);
    var road = Math.round(milesBetween(FIT.base, ll) * FIT.roadFactor);
    return { outside: out, inArea: out <= FIT.buffer + 1e-9, roadMiles: road, travelInc: out > 0 ? road * FIT.trips * FIT.rate * (1 + FIT.vat) : 0 };
  }

  // ---- Preview drawing ----
  function previewSvg(cfg, p, pr, uid) {
    var ww = Math.max(100, pr.w || 1000), hh = Math.max(100, pr.h || 600);
    var sc = Math.min(820 / ww, 440 / hh), vw = ww * sc, vh = hh * sc;
    var ox = 120 + (820 - vw) / 2, oy = 30 + (440 - vh) / 2, d;
    if (p.shape === 'l') { var cx = ox + vw * 0.44, cy = oy + vh * 0.56; d = 'M' + r1(ox) + ' ' + r1(oy) + ' H' + r1(cx) + ' V' + r1(cy) + ' H' + r1(ox + vw) + ' V' + r1(oy + vh) + ' H' + r1(ox) + ' Z'; }
    else if (p.shape === 't') { var l = ox + vw * 0.34, rr = ox + vw * 0.66, by = oy + vh * 0.62; d = 'M' + r1(l) + ' ' + r1(oy) + ' H' + r1(rr) + ' V' + r1(by) + ' H' + r1(ox + vw) + ' V' + r1(oy + vh) + ' H' + r1(ox) + ' V' + r1(by) + ' H' + r1(l) + ' Z'; }
    else d = 'M' + r1(ox) + ' ' + r1(oy) + ' H' + r1(ox + vw) + ' V' + r1(oy + vh) + ' H' + r1(ox) + ' Z';
    var items = [], i;
    for (i = 0; i < Math.min(intOf(p.cuts.socket), 6); i++) items.push('s');
    for (i = 0; i < Math.min(intOf(p.cuts.hole), 6); i++) items.push('h');
    var my = p.shape === 'rectangle' ? oy + vh * 0.6 : oy + vh * 0.82, marks = '';
    items.forEach(function (t, k) {
      var mx = ox + vw * (k + 1) / (items.length + 1);
      marks += t === 's' ? 'M' + r1(mx - 24) + ' ' + r1(my - 17) + ' h48 v34 h-48 Z ' : 'M' + r1(mx - 13) + ' ' + r1(my) + ' a13 13 0 1 0 26 0 a13 13 0 1 0 -26 0 Z ';
    });
    var by2 = oy + vh + 22, lx = ox - 22, hLx = lx - 26, hLy = oy + vh / 2;
    var dims = 'M' + r1(ox) + ' ' + r1(by2) + ' H' + r1(ox + vw) + ' M' + r1(ox) + ' ' + r1(by2 - 9) + ' V' + r1(by2 + 9) + ' M' + r1(ox + vw) + ' ' + r1(by2 - 9) + ' V' + r1(by2 + 9) +
      ' M' + r1(lx) + ' ' + r1(oy) + ' V' + r1(oy + vh) + ' M' + r1(lx - 9) + ' ' + r1(oy) + ' H' + r1(lx + 9) + ' M' + r1(lx - 9) + ' ' + r1(oy + vh) + ' H' + r1(lx + 9);
    var gid = 'cgxS' + uid, fill = cfg.mirror ? 'url(#cgxM' + uid + ')' : cfg.hex;
    return '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".35"/><stop offset=".45" stop-color="#fff" stop-opacity="0"/><stop offset=".7" stop-color="#fff" stop-opacity=".18"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>' +
      (cfg.mirror ? '<linearGradient id="cgxM' + uid + '" x1="0" y1="0" x2="1" y2=".4"><stop offset="0" stop-color="' + cfg.hex + '"/><stop offset=".45" stop-color="#f4f1ec" stop-opacity=".9"/><stop offset="1" stop-color="' + cfg.hex + '"/></linearGradient>' : '') + '</defs>' +
      '<path d="' + d + '" fill="' + fill + '"/><path d="' + d + '" fill="url(#' + gid + ')"/>' +
      (marks ? '<path d="' + marks + '" fill="#fff" fill-opacity=".85" stroke="#1c2228" stroke-opacity=".55" stroke-width="3"/>' : '') +
      '<path d="' + dims + '" fill="none" stroke="#545a61" stroke-width="3"/>' +
      '<text x="' + r1(ox + vw / 2) + '" y="' + r1(by2 + 42) + '" text-anchor="middle" font-size="34" font-weight="700" fill="#1c2228">' + Math.round(ww) + ' mm</text>' +
      '<text x="' + r1(hLx) + '" y="' + r1(hLy) + '" text-anchor="middle" font-size="34" font-weight="700" fill="#1c2228" transform="rotate(-90 ' + r1(hLx) + ' ' + r1(hLy) + ')">' + Math.round(hh) + ' mm</text>';
  }

  function init(root) {
    if (root.getAttribute('data-ready') === '1') return;
    root.setAttribute('data-ready', '1');
    var ds = root.dataset;
    var cfg = {
      rate: Number(ds.rate) || 0, min: Number(ds.min) || 0, mirror: ds.mirror === '1', printed: ds.printed === '1',
      customColour: ds.customColour === '1', hex: ds.finishHex || '#d8d3c8', finish: ds.finish || '', gid: ds.productGid || '',
      profile: ds.profile || '', api: ds.api || 'https://creoglass-os-prod.onrender.com/api/public/configurator'
    };
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var out = function (k) { return root.querySelector('[data-out="' + k + '"]'); };
    var inp = function (k) { return root.querySelector('[data-in="' + k + '"]'); };
    var list = $('[data-panels]'), tpl = $('[data-panel-tpl]');

    // The theme's sticky product column clips a long configurator.
    var info = root.closest('.product-information--inner');
    if (info) { info.classList.add('sticky-scroller--disabled', 'cgc-has-configurator'); info.style.height = 'auto'; info.style.maxHeight = 'none'; info.style.overflow = 'visible'; }

    var S = { service: 'supply', panels: [], openId: null, attempted: false, busy: false, pc: { status: 'none' } };
    var seq = 0;

    function newPanel() {
      seq += 1;
      var el = tpl.content.firstElementChild.cloneNode(true);
      var p = { id: 'p' + seq, el: el, name: '', shape: 'rectangle', w: '1000', h: '600', qty: 1, cuts: { socket: 0, hole: 0, notch: 0, custom: 0 }, cutOpen: false, uid: seq };
      wire(p);
      list.appendChild(el);
      S.panels.push(p);
      S.openId = p.id;
      return p;
    }
    function q(p, k) { return p.el.querySelector('[data-p="' + k + '"]'); }
    function label(p, i) { return p.name || ('Panel ' + (i + 1)); }
    function files(p) { var f = q(p, 'file'); return Array.prototype.slice.call((f && f.files) || []); }

    function wire(p) {
      q(p, 'toggle').addEventListener('click', function () { S.openId = S.openId === p.id ? null : p.id; render(); });
      Array.prototype.forEach.call(p.el.querySelectorAll('[data-chip]'), function (b) {
        b.addEventListener('click', function () { p.name = b.textContent; q(p, 'name').value = p.name; render(); });
      });
      q(p, 'name').addEventListener('input', function () { p.name = this.value.trim(); render(); });
      Array.prototype.forEach.call(p.el.querySelectorAll('[data-shape]'), function (b) {
        b.addEventListener('click', function () { p.shape = b.getAttribute('data-shape'); render(); });
      });
      ['w', 'h'].forEach(function (k) {
        var el = q(p, k);
        el.addEventListener('input', function () { var v = this.value.replace(/[^0-9]/g, '').slice(0, 4); if (v !== this.value) this.value = v; p[k] = v; render(); });
      });
      q(p, 'qty-').addEventListener('click', function () { p.qty = Math.max(1, p.qty - 1); render(); });
      q(p, 'qty+').addEventListener('click', function () { p.qty = Math.min(MAX_QTY, p.qty + 1); render(); });
      q(p, 'cutToggle').addEventListener('click', function () { p.cutOpen = !p.cutOpen; render(); });
      Array.prototype.forEach.call(p.el.querySelectorAll('[data-cut]'), function (b) {
        b.addEventListener('click', function () { var k = b.getAttribute('data-cut'); p.cuts[k] = Math.max(0, Math.min(MAX_CUT, intOf(p.cuts[k]) + Number(b.getAttribute('data-d')))); render(); });
      });
      q(p, 'file').addEventListener('change', render);
      q(p, 'remove').addEventListener('click', function () {
        if (S.panels.length < 2) return;
        S.panels = S.panels.filter(function (x) { return x !== p; });
        p.el.remove();
        if (S.openId === p.id) S.openId = S.panels[0].id;
        render();
      });
    }

    function areaState() {
      var pc = S.pc;
      if (S.service !== 'fit' || pc.status !== 'ok') return null;
      return pc.fit;
    }

    function collectErrors(rows) {
      var e = [];
      if (!(cfg.rate > 0) || !(cfg.min > 0)) e.push('Online pricing is not set up for this product. Please contact us.');
      rows.forEach(function (r, i) {
        var p = S.panels[i], nm = label(p, i);
        if (!(r.pr.w >= 100) || !(r.pr.h >= 100)) e.push(nm + ': enter the width and height');
        else if (r.lim.w || r.lim.h) e.push(nm + ': check the width and height');
        if (r.pr.needsFile && !files(p).length) e.push(nm + ': add a drawing or marked-up photo');
      });
      if (!inp('postcode').value.trim()) e.push('Add your postcode');
      if (S.service === 'fit') {
        if (!inp('cname').value.trim() || !inp('cemail').value.trim() || !inp('cphone').value.trim()) e.push('Add your name, email and phone');
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp('cemail').value.trim())) e.push('Check your email address');
        var a = areaState();
        if (a && !a.inArea) e.push('We measure and fit inside the M25 and up to 20 miles beyond. Choose "Delivered to you" for this postcode');
      } else if (!inp('dims').checked) e.push('Tick to confirm these are finished panel sizes');
      if (inp('colour') && !inp('colour').checked) e.push(cfg.mirror ? 'Tick the mirror tint note, or order a sample first' : 'Tick the colour note, or order a sample first');
      if (cfg.customColour && inp('colourref') && !inp('colourref').value.trim()) e.push('Enter the exact colour reference for this custom colour');
      return e;
    }

    function render() {
      var fit = S.service === 'fit', t = { qty: 0, area: 0, glass: 0, cut: 0, shape: 0 }, many = S.panels.length > 1;
      var rows = S.panels.map(function (p, i) {
        var pr = panelPrice(cfg, p), lim = limitErrors(cfg, pr.w, pr.h), open = S.openId === p.id, f = files(p);
        t.qty += pr.q; t.area += pr.charge; t.glass += pr.glass; t.cut += pr.cutouts; t.shape += pr.shaping;
        p.el.classList.toggle('is-open', open);
        q(p, 'toggle').setAttribute('aria-expanded', open ? 'true' : 'false');
        q(p, 'body').hidden = !open;
        q(p, 'label').textContent = label(p, i);
        var sm = (pr.w || '–') + ' × ' + (pr.h || '–') + ' mm';
        if (pr.q > 1) sm += ' · ×' + pr.q;
        if (p.shape !== 'rectangle') sm += ' · ' + SHAPE_LABEL[p.shape];
        if (pr.cutCount) sm += ' · ' + pr.cutCount + (pr.cutCount === 1 ? ' cut-out' : ' cut-outs');
        q(p, 'summary').textContent = sm;
        q(p, 'price').textContent = moneyVat(pr.total);
        Array.prototype.forEach.call(p.el.querySelectorAll('[data-chip]'), function (b) { b.classList.toggle('is-on', b.textContent === p.name); });
        Array.prototype.forEach.call(p.el.querySelectorAll('[data-shape]'), function (b) { var on = b.getAttribute('data-shape') === p.shape; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
        var wId = root.id + '-' + p.id + '-w', hId = root.id + '-' + p.id + '-h';
        q(p, 'w').id = wId; q(p, 'wLbl').setAttribute('for', wId); q(p, 'h').id = hId; q(p, 'hLbl').setAttribute('for', hId);
        var wMiss = S.attempted && p.w === '', hMiss = S.attempted && p.h === '';
        var wErr = lim.w || (wMiss ? 'Enter the width' : ''), hErr = lim.h || (hMiss ? 'Enter the height' : '');
        q(p, 'w').classList.toggle('is-bad', !!wErr); q(p, 'h').classList.toggle('is-bad', !!hErr);
        q(p, 'w').setAttribute('aria-invalid', wErr ? 'true' : 'false'); q(p, 'h').setAttribute('aria-invalid', hErr ? 'true' : 'false');
        q(p, 'wErr').hidden = !wErr; q(p, 'wErr').textContent = wErr; q(p, 'hErr').hidden = !hErr; q(p, 'hErr').textContent = hErr;
        q(p, 'qty').textContent = pr.q;
        q(p, 'qty-').disabled = pr.q <= 1; q(p, 'qty+').disabled = pr.q >= MAX_QTY;
        if (open) q(p, 'svg').innerHTML = previewSvg(cfg, p, pr, p.uid);
        q(p, 'cutToggle').setAttribute('aria-expanded', p.cutOpen ? 'true' : 'false');
        q(p, 'cutBadge').textContent = pr.cutCount ? (pr.cutCount + ' added · ' + moneyVat(pr.cutouts)) : (p.cutOpen ? 'Close' : 'None · add');
        q(p, 'cuts').hidden = !p.cutOpen;
        q(p, 'cutNote').hidden = pr.q < 2;
        Object.keys(CUT_PRICE).forEach(function (k) {
          p.el.querySelector('[data-count="' + k + '"]').textContent = intOf(p.cuts[k]);
          p.el.querySelector('[data-cut="' + k + '"][data-d="-1"]').disabled = intOf(p.cuts[k]) <= 0;
          p.el.querySelector('[data-cut="' + k + '"][data-d="1"]').disabled = intOf(p.cuts[k]) >= MAX_CUT;
        });
        var upl = q(p, 'upl');
        upl.hidden = !pr.needsFile;
        upl.classList.toggle('is-req', pr.needsFile && !f.length && !S.attempted);
        upl.classList.toggle('is-miss', pr.needsFile && !f.length && S.attempted);
        q(p, 'files').hidden = !f.length;
        q(p, 'files').textContent = f.map(function (x) { return x.name; }).join(' · ');
        q(p, 'alt').hidden = pr.needsFile;
        q(p, 'area').textContent = pr.charge.toFixed(2) + ' m²';
        q(p, 'remove').hidden = !many;
        return { pr: pr, lim: lim };
      });
      var total = t.glass + t.cut + t.shape;
      out('count').textContent = S.panels.length === 1 ? '1 panel' : S.panels.length + ' panels';
      $$('[data-svc]').forEach(function (b) { var on = b.getAttribute('data-svc') === S.service; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      $$('[data-show]').forEach(function (el) { el.hidden = el.getAttribute('data-show') !== S.service; });
      out('step3').textContent = fit ? 'Where and who' : 'Delivery';
      out('pchint').textContent = fit ? 'We fit inside the M25 at no extra cost. Up to 20 miles beyond it, mileage for the survey and installation visits is added to your quote.' : 'We use this to work out delivery. You will see the delivery charge at checkout.';
      renderArea();
      out('sPanels').textContent = String(t.qty);
      out('sAreaLbl').textContent = (cfg.mirror ? 'Mirror' : 'Glass') + ' (' + t.area.toFixed(2) + ' m²)';
      out('sGlass').textContent = moneyEx(t.glass);
      out('rowCut').hidden = !(t.cut > 0); out('sCut').textContent = moneyEx(t.cut);
      out('rowShape').hidden = !(t.shape > 0); out('sShape').textContent = moneyEx(t.shape);
      out('sDelLbl').textContent = fit ? 'Survey and installation' : 'Delivery';
      out('sDel').textContent = fit ? 'In your quote' : 'At checkout';
      out('totLbl').textContent = fit ? (cfg.mirror ? 'Mirror estimate' : 'Glass estimate') : 'Total';
      out('sTotal').textContent = moneyVat(total);
      var incEl = out('sInc'); if (incEl) incEl.textContent = 'Total including VAT: ' + money(total);
      out('barLbl').textContent = fit ? 'Estimate' : 'Total';
      out('barTotal').textContent = moneyVat(total);
      out('barCta').textContent = fit ? 'Review' : 'Review and pay';
      out('lead').textContent = fit ? 'Typically 3–4 weeks from survey to installation' : 'Made to order · usually 2–3 weeks';
      var cta = $('[data-act="submit"]');
      if (!S.busy) cta.textContent = fit ? 'Send for a quote' : 'Continue to secure checkout';
      out('secure').textContent = fit ? 'No payment now. The team will be in touch to arrange a survey.' : 'Secure checkout by Shopify.';
      var tickD = $('[data-tick="dims"]'), tickC = $('[data-tick="colour"]');
      if (tickD) tickD.classList.toggle('is-bad', S.attempted && !fit && !inp('dims').checked);
      if (tickC) tickC.classList.toggle('is-bad', S.attempted && !inp('colour').checked);
      inp('postcode').classList.toggle('is-bad', S.attempted && !inp('postcode').value.trim());
      var errs = collectErrors(rows), box = out('errs');
      if (S.attempted && errs.length && !S.busy) {
        box.hidden = false;
        box.innerHTML = 'Almost there. Please check:<ul>' + errs.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
      } else box.hidden = true;
      S.rows = rows; S.total = total; S.errs = errs;
      return errs;
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    function renderArea() {
      var el = out('area'), pc = S.pc;
      el.className = 'cgx__area';
      if (S.service !== 'fit' || pc.status === 'none') { el.hidden = true; return; }
      el.hidden = false;
      if (pc.status === 'loading') { el.textContent = 'Checking your postcode…'; return; }
      if (pc.status === 'bad') { el.textContent = 'We couldn\'t find that postcode. Please check it. We\'ll confirm the fitting area with your quote.'; return; }
      var a = pc.fit;
      if (!a.inArea) { el.classList.add('is-bad'); el.innerHTML = 'Sorry, this postcode is outside our fitting area (inside the M25 and up to 20 miles beyond). We can make your splashback to measure and deliver it. <button type="button" class="cgx__link" data-act="to-supply">Switch to delivered</button>'; return; }
      el.classList.add('is-ok');
      el.textContent = a.outside === 0 ? 'Good news: you\'re inside the M25, so there\'s no travel charge.'
        : 'Good news: we fit in your area. You\'re about ' + Math.max(1, Math.round(a.outside)) + ' miles outside the M25, so mileage for the survey and installation visits (about £' + Math.round(a.travelInc / (1 + FIT.vat)) + ' + VAT) is added to your quote.';
    }

    var lookupTimer, lookupSeq = 0;
    function lookup() {
      var raw = inp('postcode').value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      clearTimeout(lookupTimer);
      if (raw.length < 2 || /^[A-Z]{1,2}$/.test(raw)) { S.pc = { status: 'none' }; render(); return; }
      lookupTimer = setTimeout(function () {
        var my = ++lookupSeq;
        S.pc = { status: 'loading' }; renderArea();
        var url = raw.length >= 5 ? 'https://api.postcodes.io/postcodes/' + encodeURIComponent(raw) : 'https://api.postcodes.io/outcodes/' + encodeURIComponent(raw);
        fetch(url).then(function (r) { return r.json(); }).then(function (j) {
          if (my !== lookupSeq) return;
          var res = j && j.result;
          S.pc = (!res || res.latitude == null) ? { status: 'bad' } : { status: 'ok', outcode: String(res.outcode || raw), fit: fitArea([res.latitude, res.longitude]) };
          render();
        }).catch(function () { if (my !== lookupSeq) return; S.pc = { status: 'none' }; render(); });
      }, 450);
    }

    // ---- Submission (same contract as v1) ----
    async function apiJson(path, payload) {
      var res = await fetch(cfg.api + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok) throw new Error(data.error || 'api_error');
      return data;
    }
    async function uploadOne(file) {
      var target = await apiJson('/file-target', { filename: file.name, mimeType: file.type || 'application/octet-stream', fileSize: file.size });
      var form = new FormData();
      (target.parameters || []).forEach(function (x) { form.append(x.name, x.value); });
      form.append('file', file, file.name);
      var up = await fetch(target.url, { method: 'POST', body: form });
      if (!up.ok) throw new Error('file_upload_failed');
      var reg = await apiJson('/file-register', { resourceUrl: target.resourceUrl, filename: file.name, mimeType: file.type || 'application/octet-stream' });
      if (!reg.url) throw new Error('file_processing_failed');
      return { name: file.name, url: reg.url, id: reg.id || '' };
    }
    function progress(pct, txt) {
      var w = out('progress'); w.hidden = pct == null; if (pct == null) return;
      out('progressTxt').textContent = txt; out('progressBar').style.width = Math.max(0, Math.min(100, pct)) + '%';
    }
    function panelPayload(p, i, drawings) {
      var cuts = {};
      Object.keys(CUT_PRICE).forEach(function (k) { cuts[k] = Math.max(0, Math.min(MAX_CUT, intOf(p.cuts[k]))); });
      return { name: label(p, i), shape: p.shape, width: intOf(p.w), height: intOf(p.h), qty: Math.max(1, intOf(p.qty)), colourName: cfg.finish, cutouts: cuts, drawings: drawings || [] };
    }
    function colourRef() { var el = inp('colourref'); return el ? el.value.trim() : ''; }
    function riskAccepted() { return cfg.printed || !!(inp('colour') && inp('colour').checked); }

    async function submit() {
      if (S.busy) return;
      S.attempted = true;
      var errs = render();
      var box = out('ok'); box.hidden = true;
      if (errs.length) { out('errs').scrollIntoView({ block: 'nearest', behavior: 'smooth' }); return; }
      var cta = $('[data-act="submit"]'), fit = S.service === 'fit';
      S.busy = true; cta.disabled = true; cta.textContent = fit ? 'Sending…' : 'Preparing secure checkout…';
      try {
        var payloadPanels = [], allFiles = 0, done = 0;
        S.panels.forEach(function (p) { allFiles += files(p).length; });
        progress(10, 'Checking your panels…');
        for (var i = 0; i < S.panels.length; i++) {
          var fl = files(S.panels[i]), drawings = [];
          for (var j = 0; j < fl.length; j++) {
            done += 1; progress(15 + Math.round(done / Math.max(1, allFiles) * 50), 'Uploading drawing ' + done + ' of ' + allFiles + '…');
            drawings.push(await uploadOne(fl[j]));
          }
          payloadPanels.push(panelPayload(S.panels[i], i, drawings));
        }
        var postcode = inp('postcode').value.trim();
        if (fit) {
          progress(80, 'Sending your design to CreoGlass…');
          var enq = {
            enquiryId: (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('CG-' + Date.now()),
            productId: cfg.gid, productFinish: cfg.finish, colourReference: colourRef(), sampleRiskAccepted: riskAccepted(),
            service: 'Survey & installation needed', postcode: postcode, total_supply_value: money1(S.total), panels: payloadPanels,
            customer: { name: inp('cname').value.trim(), email: inp('cemail').value.trim(), phone: inp('cphone').value.trim(), postcode: postcode }
          };
          var r = await apiJson('/enquiry', enq);
          progress(100, 'Sent');
          box.hidden = false; box.textContent = 'Thank you. Your design has been sent to the CreoGlass team. Reference: ' + (r.enquiryId || 'received') + '. We\'ll be in touch to arrange your survey.';
          cta.textContent = 'Sent';
          if (window.dataLayer) window.dataLayer.push({ event: 'splash_config_enquiry', value: Math.round(S.total), currency: 'GBP' });
          setTimeout(function () { progress(null); }, 1500);
          return; // keep the button disabled after a successful enquiry
        }
        progress(85, 'Creating your secure checkout…');
        var res = await fetch(cfg.api + '/checkout', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ productId: cfg.gid, colourReference: colourRef(), sampleRiskAccepted: riskAccepted(), panels: payloadPanels, postcode: postcode, dimensionsConfirmed: inp('dims').checked })
        });
        var data = await res.json().catch(function () { return {}; });
        if (!res.ok || !data.checkoutUrl) throw new Error(data.error || 'checkout_failed');
        progress(100, 'Opening secure checkout…');
        if (window.dataLayer) window.dataLayer.push({ event: 'splash_config_checkout', value: Math.round(S.total), currency: 'GBP' });
        setTimeout(function () { window.location.href = data.checkoutUrl; }, 300);
      } catch (err) {
        var m = String((err && err.message) || '');
        progress(null);
        S.busy = false; cta.disabled = false; render();
        var eb = out('errs'); eb.hidden = false;
        eb.innerHTML = fit
          ? (m === 'crm_submission_failed' ? 'We couldn\'t reach our sales system. Please try again, or email <a href="mailto:sales@creoglass.co.uk">sales@creoglass.co.uk</a>.' : 'Your design could not be sent. Please check the details and try again.')
          : (m.indexOf('file_') > -1 ? 'A drawing could not be uploaded. Please try the file again.' : 'We couldn\'t open the checkout. Please try again, or email <a href="mailto:sales@creoglass.co.uk">sales@creoglass.co.uk</a>.');
      }
    }

    // ---- Events ----
    root.addEventListener('click', function (ev) {
      var svc = ev.target.closest('[data-svc]');
      if (svc) { S.service = svc.getAttribute('data-svc'); out('ok').hidden = true; render(); return; }
      var a = ev.target.closest('[data-act]'); if (!a) return;
      var act = a.getAttribute('data-act');
      if (act === 'add') { newPanel(); render(); var np = S.panels[S.panels.length - 1]; np.el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
      else if (act === 'submit') submit();
      else if (act === 'to-supply') { S.service = 'supply'; render(); }
    });
    inp('postcode').addEventListener('input', function () { lookup(); if (S.attempted) render(); });
    ['cname', 'cemail', 'cphone', 'colourref'].forEach(function (k) { var el = inp(k); if (el) el.addEventListener('input', function () { if (S.attempted) render(); }); });
    ['dims', 'colour'].forEach(function (k) { var el = inp(k); if (el) el.addEventListener('change', render); });

    // Mobile price bar: visible while the configurator is on screen and the summary is not.
    var bar = out('bar'), inView = false, sumVis = false;
    function barState() { bar.hidden = !(inView && !sumVis); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { inView = en[0].isIntersecting; barState(); }, { threshold: 0 }).observe(list);
      new IntersectionObserver(function (en) { sumVis = en[0].isIntersecting; barState(); }, { threshold: 0.2 }).observe($('[data-sum]'));
    }

    newPanel();
    render();
  }

  if (typeof window !== 'undefined') window.CGSplashV2 = { price: panelPrice, limits: limitErrors, fitArea: fitArea };
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-cgx]'), init); }
  if (typeof document !== 'undefined') { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot(); }
  if (typeof module !== 'undefined') module.exports = { panelPrice: panelPrice, limitErrors: limitErrors, fitArea: fitArea, milesOutsideM25: milesOutsideM25 };
})();
